import { render, staticRenderFns } from "./InterProcessConfigurationDetails.vue?vue&type=template&id=fbf03d84&"
import script from "./InterProcessConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./InterProcessConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbf03d84')) {
      api.createRecord('fbf03d84', component.options)
    } else {
      api.reload('fbf03d84', component.options)
    }
    module.hot.accept("./InterProcessConfigurationDetails.vue?vue&type=template&id=fbf03d84&", function () {
      api.rerender('fbf03d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/InterProcess/InterProcessConfigurationDetails.vue"
export default component.exports